module.exports = {
      id: "payment-2-usage",
      viewBox: "0 0 37 31",
      url: __webpack_public_path__ + "img/icons.b9c19baa.svg#payment-2-usage",
      toString: function () {
        return this.url;
      }
    }